import { LocationSearchResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type LocationSearchResponseInput = z.input<typeof LocationSearchResponseSchema>;
export type LocationSearchResponseOutput = z.output<typeof LocationSearchResponseSchema>;

export function serializeLocationSearchResponse(payload: LocationSearchResponseInput): LocationSearchResponseOutput {
  return LocationSearchResponseSchema.parse(payload);
}
